var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "m-0 p-0 rounded",
      class: this.$vuetify.theme.dark ? "grey darken-4" : "grey lighten-5",
      attrs: { fluid: "" },
    },
    [
      _vm.showUserSelect
        ? _c("SelectUser", { on: { userSelected: _vm.usersSelected } })
        : _vm._e(),
      _vm.showAbsenceOverview
        ? _c("AbsenceOverview", {
            attrs: { date: _vm.date, usersId: _vm.users },
            on: {
              selectUser: function ($event) {
                _vm.showAbsenceOverview = false
                _vm.showUserSelect = true
                _vm.users = []
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }